import { I18N } from '@/app'
import { verifyProfanity } from '@/utils'

export const validatePulseComment = (value: string) => {
  const MIN_CHARACTERS = 6

  const valid = true

  const { isProfanity, profanities } = verifyProfanity(value)

  if (isProfanity) {
    return {
      valid: false,
      message: I18N.t('form.validations.profanity', { words: profanities.join(', ') })
    }
  }

  if (value?.trim()?.length < MIN_CHARACTERS) {
    return {
      valid: false,
      message: I18N.t('form.validations.min', {
        min: MIN_CHARACTERS
      })
    }
  }

  return {
    valid: true,
    message: ''
  }
}
